<!--Basics of this component
its just a modal to provide dialoges around deleting someone
-->

<template>
  <div>
    <b-modal
      id="person-delete-modal"
      :title="'Delete ' + person.firstName + ' ' + person.lastName"
      @hidden="cancelModal('cancelled')"
      @cancel="cancelModal('cancelled')"
      :busy="false"
      return-focus="body"
    >
    <h4> You are about to delete</h4>
      <p>{{ person.firstName }} {{person.lastName}} who's id is {{ person.id }}</p>

      <p>
        When you press DELETE all of their data will be removed and you will be taken the people list
        view, because this person wont be here anymore. 
      </p>
      <p>I know it's obvious but please dont do this unless you really want to delete them for good</p>

      <div v-if="error != null" class="text-center">
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        <h4>{{ error.Message }}</h4>
        <div>{{ error.Reason }}</div>
      </div>
      <template #modal-footer = "{ ok, cancel, hide }"
        >
        <b-button @click = "cancel()">Cancel</b-button>
        <b-button variant="danger" @click="deleteRecord(person.id)"
          >Delete</b-button
        ></template
      >
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  mounted() {
    this.$bvModal.show("person-delete-modal");
  },
  data() {
    return {
      test: "this is the DeletePerson.vue component",
      response: null,
      error: null,
    };
  },

  computed: {
    person() {
      return this.$store.getters.person;
    },
  },

  methods: {
    deleteRecord(id) {
      axios
        .delete(this.$store.getters.urlPrefix + "api/person_delete/" + id + "/")
        .then((response) => {
          //handdle sucess
          this.response = response;
          this.cancelModal();
        })
        .catch((error) => {
          //handle error
          this.error = error.response.data;
        });
    },
    //   this.$store.dispatch("genericPostApiCall", payload).then((resolve) => {
    //     // We need the id of the newly created person (yes we could use this.person.id from the computed person object)
    //     // but this is nice and explicit.
    //     // now navigate to responsible person page which will set up the data correctly
    //     const responsiblePersonId = resolve.data.id;
    //     this.$router.push({
    //       name: "personDetail",
    //       params: { id: responsiblePersonId },
    //     });
    //     this.cancelModal();
    //   });
    // },

    cancelModal(action) {
      if (action != "cancelled"|| action == undefined) {
        this.$bvModal.hide("person-delete-modal");
        this.$router.push({ name: "people" });
        return;
      }
      
      this.$router.push({ name: "personDetail", id:this.person.id });
    },
  },
};
</script>

<style scoped></style>
